import { computed, reactive, watch } from 'vue'

export const useFeedbackFilter = (callback: (params: FeedbackFilterParams) => void) => {
  const filterParameter = reactive<FeedbackFilterParams>({
    spontaneous: false,
    structured: false,
    sent: false,
    received: false,
    memberIds: [],
  })

  const toggleSpontaneous = () => (filterParameter.spontaneous = !filterParameter.spontaneous)
  const toggleStructured = () => (filterParameter.structured = !filterParameter.structured)
  const toggleSent = () => (filterParameter.sent = !filterParameter.sent)
  const toggleReceived = () => (filterParameter.received = !filterParameter.received)
  const toggleMemberId = (memberId: string) => {
    if (filterParameter.memberIds.find((id) => id == memberId)) {
      filterParameter.memberIds = filterParameter.memberIds.filter((id) => id != memberId)
    } else {
      filterParameter.memberIds.push(memberId)
    }
  }

  const resetFilters = () => {
    filterParameter.spontaneous = false
    filterParameter.structured = false
    filterParameter.sent = false
    filterParameter.received = false
    filterParameter.memberIds = []
  }

  const applyFilter = () => {
    callback(filterParameter)
  }

  const hasFilter = computed(() => {
    return (
      filterParameter.memberIds.length > 0 ||
      filterParameter.received ||
      filterParameter.sent ||
      filterParameter.spontaneous ||
      filterParameter.structured
    )
  })

  watch(filterParameter, () => {
    applyFilter()
  })

  return {
    filterParameter,
    toggleSpontaneous,
    toggleStructured,
    toggleSent,
    toggleReceived,
    toggleMemberId,
    resetFilters,
    hasFilter,
  }
}

export type FeedbackFilterParams = {
  spontaneous: boolean
  structured: boolean
  sent: boolean
  received: boolean
  memberIds: string[]
  limit?: number
}
